import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isDate, isInteger, hideWhenDisplaying, hideWhenCreating } from 'src/types/columnFlags';
const controlledActions = {
    create: [250],
    fetch: [248, 249],
    update: [251, 252],
    delete: [253, 254],
    downloadList: [248, 249],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'row_menu', type: 'row_menu', hideWhenCreating, menuItemShortcuts: ['delete'] },
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreating },
        { name: 'subject', inlineEdit: true, /* subject is by default not used */ hideWhenCreating },
        { name: 'body', 'label': 'Comment', inlineEdit: true },
        { name: 'created_by_user_id', hideWhenDisplaying, hideWhenCreating },
        { name: 'created_at', hideWhenDisplaying, hideWhenCreating },
        { name: 'scope_org_id', hideWhenDisplaying, hideWhenCreating },
        { name: 'month', isDate, hideWhenDisplaying, hideWhenCreating },
        { name: 'quarter', isDate, hideWhenDisplaying, hideWhenCreating },
        { name: 'year', isDate, hideWhenDisplaying, hideWhenCreating },
        { name: 'metric_type_id', hideWhenDisplaying, hideWhenCreating },
        { name: 'comment_type', hideWhenDisplaying, hideWhenCreating },
        { name: 'commentable_entity', hideWhenDisplaying, hideWhenCreating },
        { name: 'commentable_id', hideWhenDisplaying, hideWhenCreating }
    ];
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'comments.comments',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Comments'
});
export default localEntity;
